import { gql } from '@apollo/client';
import { Schema } from './schema';
import { FileType } from '@jbc-year-end-adj/2024/types';
import { NewOrOldType, LIFE_INSURANCES_FRAGMENT } from '../query';

type LifeInsuranceType = 'GeneralLifeInsurance' | 'NursingMedicalInsurance' | 'IndividualAnnuityInsurance';

export type QueryVariables = {
  input: {
    lifeInsurances: LifeInsurance[];
  };
};

type LifeInsurance = {
  id?: string | undefined;
  type: LifeInsuranceType;
  image: File | FileType | null;
  amount: string;
  insuranceDuration: string;
  insuranceType: string;
  name: string;
  nameOfContractor: string;
  nameOfRecipient: string;
  newOrOld: NewOrOldType;
  paymentStartDate?: string;
};

export const convertFormDataToQueryVariables = (data: Schema): QueryVariables => {
  const lifeInsurances = convertLifeInsuranceAttributes(data.lifeInsurances);

  return {
    input: {
      lifeInsurances
    }
  };
};

const convertLifeInsuranceAttributes = (insurances: Schema['lifeInsurances']): LifeInsurance[] => {
  return insurances.map(insurance => {
    const newOrOld = insurance.lifeInsuranceType === 'NursingMedicalInsurance' ? 'new_type' : insurance.newOrOld;

    const paymentStartDate = insurance.lifeInsuranceType === 'IndividualAnnuityInsurance' ? insurance.paymentStartDate : undefined;

    return {
      id: insurance.id,
      type: insurance.lifeInsuranceType,
      name: insurance.name,
      insuranceType: insurance.insuranceType,
      insuranceDuration: insurance.insuranceDuration,
      nameOfContractor: insurance.nameOfContractor,
      nameOfRecipient: insurance.nameOfRecipient,
      newOrOld,
      amount: insurance.amount,
      image: insurance.image,
      paymentStartDate
    };
  });
};

export const ANSWER_LIFE_INSURANCES = gql`
  mutation AnswerLifeInsurances($input: AnswerLifeInsurancesInput!) {
    answerLifeInsurances(input: $input) {
      questions {
        id
        status
      }
      profile {
        id
        ...LifeInsurances
      }
    }
  }
  ${LIFE_INSURANCES_FRAGMENT}
`;
